import { EntityType } from '@frontend/common';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface RefetchTrigger {
    timestamp: number;
}

interface DetailModalState {
    refetchTriggers: Record<string, RefetchTrigger>; // key format: "{entityType}:{entityId}"
}

const initialState: DetailModalState = {
    refetchTriggers: {}
};

const getRefetchKey = (entityType: EntityType, entityId: string): string => {
    return `${entityType}:${entityId}`;
};

const detailModalSlice = createSlice({
    name: 'detailModal',
    initialState,
    reducers: {
        triggerRefetch(state, action: PayloadAction<{ entityType: EntityType; entityId: string }>) {
            const key = getRefetchKey(action.payload.entityType, action.payload.entityId);
            state.refetchTriggers[key] = {
                timestamp: Date.now()
            };
        },
        clearRefetchTrigger(state, action: PayloadAction<{ entityType: EntityType; entityId: string }>) {
            const key = getRefetchKey(action.payload.entityType, action.payload.entityId);
            delete state.refetchTriggers[key];
        },
        clearAllRefetchTriggers(state) {
            state.refetchTriggers = {};
        }
    }
});

export const detailModalStore = { detailModal: detailModalSlice.reducer };
export const { triggerRefetch, clearRefetchTrigger, clearAllRefetchTriggers } = detailModalSlice.actions;
export { getRefetchKey };
